import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import { useCallback } from 'react'

import commonRepo from '@/repository/common.repo'
import modalService from '@/service/modal.service'
import WebviewService from '@/service/webview.service'
import {
  connectToScienceflat,
  getScienceflatBaseUrl,
  openScienceflat,
} from '@/utils/scienceflatUtils'

export const useScienceflatConnect = () => {
  return useCallback(async () => {
    if (!commonRepo.user || !commonRepo.academy) return

    // 스쿨플랫은 사이언스플랫을 별도 브랜드로 노출하지 않고 자기 과목("스쿨플랫 과학")으로 부른다.
    const isSchoolflat = commonRepo.isSchoolflat
    const serviceName = isSchoolflat ? '스쿨플랫 과학' : '사이언스플랫'

    try {
      if (commonRepo.user.isScienceflatAllowed && commonRepo.academy.isScienceflatAllowed) {
        await openScienceflat()
      } else {
        if (commonRepo.user.isAdmin) {
          modalService.openConfirmModal({
            content: (
              <ScienceflatConsentContent>
                <p className="title">{serviceName} 이용 동의</p>
                {isSchoolflat ? (
                  <p>
                    스쿨플랫 과학 과목을 처음 이용하실 때 한번의 동의가 필요해요.
                    <br />
                    동의하고 바로 스쿨플랫 과학 과목을 사용해보세요.
                  </p>
                ) : (
                  <p>
                    매쓰플랫 선생님은 <strong>사이언스플랫을 무료로 이용</strong>하실 수 있어요!
                    <br />
                    사이언스플랫은 새로운 서비스라 처음 이용하실 때 한번의 동의가 필요해요.
                    <br />
                    동의하고 바로 사이언스플랫을 사용해보세요.
                  </p>
                )}
              </ScienceflatConsentContent>
            ),
            actionButtonText: '동의',
            cancelButtonText: '취소',
            onClick: async () => {
              await connectToScienceflat(
                `${getScienceflatBaseUrl()}/mathflat/callback`,
                !WebviewService.isAppAndroid,
              )
              modalService.closeModal()
            },
          })
        } else {
          modalService.openConfirmModal({
            content: (
              <ScienceflatNoPermissionContent>
                <p className="body-text">
                  선생님, {serviceName} 이용 권한이 없습니다.
                  <br />
                  관리자 선생님에게 이용 권한을 요청해주세요!
                </p>
                <p className="sub-text">
                  (관리자 선생님이 {serviceName} &apos;운영 관리&apos; &gt; &apos;선생님
                  관리&apos;에서 권한을 설정할 수 있습니다.)
                </p>
              </ScienceflatNoPermissionContent>
            ),
            actionButtonText: '확인',
            hasCancelButton: false,
            onClick: modalService.closeModal,
          })
        }
      }
    } catch {
      modalService.openConfirmModal({
        content: `${serviceName} 연동 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.`,
        actionButtonText: '확인',
        hasCancelButton: false,
        onClick: modalService.closeModal,
      })
    }
  }, [])
}

const ScienceflatConsentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  ${typo.body02};
  color: var(--Colors-Gray-900);

  .title {
    ${typo.heading05};
    font-weight: 700;
    color: var(--Colors-Gray-900);
  }

  strong {
    color: var(--Colors-Sky-400);
  }
`

const ScienceflatNoPermissionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;

  .body-text {
    ${typo.body02};
    color: var(--Colors-Gray-900);
  }

  .sub-text {
    ${typo.caption01};
    color: var(--Colors-Gray-700);
  }
`
